import { Link } from "zudoku/router"

const steps = [
    "Register for a developer account to receive test API credentials.",
    "Review the API documentation and integration guide.",
    "Build and test your integration ahead of submitting your application.",
    "Submit your CBN sandbox application with evidence of technical readiness.",
]

export const GetStarted = ({ className }: { className?: string }) => (
    <section id="get-started" className={`scroll-mt-[var(--header-height)] ${className ?? ""}`}>
        <div className="max-w-3xl mx-auto">
            <div className="text-center mb-16">
                <h2 className="text-3xl font-bold mb-4">Get Started</h2>
                <p className="text-lg text-muted-foreground">
                    A clear path from registration to a submission-ready application.
                </p>
            </div>
            <div className="relative mb-10">
                {steps.map((step, i) => (
                    <div key={step} className="flex gap-6 relative">
                        <div className="flex flex-col items-center">
                            <div className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm z-10 flex-shrink-0">
                                {i + 1}
                            </div>
                            {i < steps.length - 1 && (
                                <div className="w-0.5 bg-border flex-1 my-1 min-h-4" />
                            )}
                        </div>
                        <div className="pb-8 flex-1 min-w-0">
                            <p className="leading-relaxed mt-1.5">{step}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm font-medium border-t border-border pt-8">
                <Link to="/products/beyond-sandbox/apis" className="text-primary hover:underline">
                    API Documentation
                </Link>
                <span className="text-muted-foreground">·</span>
                <a
                    href="https://sandbox.cbn.gov.ng"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                >
                    Register for Test Credentials
                </a>
                <span className="text-muted-foreground">·</span>
                <a
                    href="https://sandbox.cbn.gov.ng"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                >
                    Sandbox Application
                </a>
            </div>
        </div>
    </section>
)